import { render, staticRenderFns } from "./BookingManagment.vue?vue&type=template&id=8460877c&scoped=true"
import script from "./BookingManagment.vue?vue&type=script&lang=js"
export * from "./BookingManagment.vue?vue&type=script&lang=js"
import style0 from "./BookingManagment.vue?vue&type=style&index=0&id=8460877c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8460877c",
  null
  
)

export default component.exports